// services/userGuideService.js

import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

export const getUserGuide = () => {
  return apiClient(ENDPOINTS.USER_GUIDE, {
    method: "GET",
  });
};
